module.exports = __webpack_public_path__ + "img/bukapo.c84cf7c2.svg";